// AI-assisted: Claude 2026-08-08, human-reviewed: ausstehend
// Video zu einer Übung. Bewusst ein LINK, kein Embed:
// die Sicherheitsregeln der App (CSP) lassen keine fremden Videos in die Seite,
// und ein Embed würde Google schon beim Öffnen der Seite Daten schicken.
import type { Exercise } from "./types"

/** Nur echte Web-Adressen durchlassen. Ein „javascript:"-Link in einem
 *  Eingabefeld wäre auch unter zehn Freunden eine echte Lücke. */
export function sichereUrl(url: string | undefined): string | null {
  if (!url) return null
  try {
    const u = new URL(url.trim())
    return u.protocol === "https:" || u.protocol === "http:" ? u.href : null
  } catch {
    return null
  }
}

/** Reihenfolge: hinterlegter Link (eigener Zettel oder Admin-Video)
 *  → sonst YouTube-Suche nach der Übung. */
export function videoUrl(ex: Pick<Exercise, "name" | "video_search_term" | "video_url">): string {
  const eigener = sichereUrl(ex.video_url)
  if (eigener) return eigener
  const q = ex.video_search_term !== "" ? ex.video_search_term : `${ex.name} Übung Ausführung`
  return `https://www.youtube.com/results?search_query=${encodeURIComponent(q)}`
}

/** Zeigt die Übung ein hinterlegtes Video (statt nur einer Suche)? */
export function hatEigenesVideo(ex: Pick<Exercise, "video_url">): boolean {
  return sichereUrl(ex.video_url) !== null
}
